// @flow
import React from 'react';
import PropTypes from 'prop-types';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { withStyles } from '@material-ui/core/styles';

import { CONFIRMED_ORDER, COMPLETED_ORDER, PICKED_UP, PARTIAL_DELIVERED_ORDER } from '../../constants';

const steps = ['Received', 'Confirmed', 'Picked up', 'Completed'];
const OrderStep = withStyles({
	root: {
		whiteSpace: 'pre-line',
		'& .MuiStepIcon-root': {
			color: 'transparent',
			border: '1px solid #808c89',
			borderRadius: '50%',
			'&.MuiStepIcon-completed': {
				color: '#bedc13',
				border: 'unset',
			},
			'& .MuiStepIcon-text': {
				// fill: '#808c89',
				fontSize: 0,
			},
		},
		'& .MuiStepLabel-label': {
			color: '#868686',
			fontWeight: 500,
			fontSize: 12,
			marginTop: 10,
		},
		'& .MuiStepConnector-line': {
			borderColor: '#808c89',
		}
	},
})(Step);

function OrderProgress({ status }: { status: string }) {
	let statusRank = 1;
	switch (status) {
		case COMPLETED_ORDER:
			statusRank = 4;
			break;

		case PICKED_UP:
		case PARTIAL_DELIVERED_ORDER:
			statusRank = 3;
			break;

		case CONFIRMED_ORDER:
			statusRank = 2;
			break;

		default:
			break;
	}

	return (
		<section style={{ width: '100%' }}>
			<Stepper alternativeLabel activeStep={statusRank} style={{ padding: '12px 0', backgroundColor: 'unset' }}>
				{steps.map((label) => (
					<OrderStep key={label}>
						<StepLabel>{label}</StepLabel>
					</OrderStep>
				))}
			</Stepper>
		</section>
	);
}

OrderProgress.propTypes = {
	status: PropTypes.string.isRequired,
};

export default OrderProgress;
